// extracted by mini-css-extract-plugin
module.exports = {"chatMessageContainer":"ChatMessage_chatMessageContainer___aZO6","fadeIn":"ChatMessage_fadeIn__zlwuN","message":"ChatMessage_message__7BHOr"};